import { AxiosResponse } from 'axios';

export const httpClientState = {
  validationPromise: null as Promise<AxiosResponse | void> | null,
};
